import type { ReactNode, ElementType } from "react";
import { cn } from "@/lib/cn";
import { useInView } from "@/hooks/useInView";

interface RevealProps {
  children: ReactNode;
  animation?: string;
  delay?: string;
  as?: ElementType;
  className?: string;
}

export function Reveal({
  children,
  animation = "animate-slide-fade-up",
  delay = "",
  as: Tag = "div",
  className,
}: RevealProps) {
  const { ref, isInView } = useInView<HTMLDivElement>();

  return (
    <Tag
      ref={ref}
      className={cn(
        isInView ? `${animation} ${delay}` : "opacity-0",
        className,
      )}
    >
      {children}
    </Tag>
  );
}
